module.exports = __webpack_public_path__ + "static/media/info_marketing.01c53b52.png";